import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Footer from './Footer';

const ErrorPage = ({ message }) => {
    const { t } = useTranslation();

    const isTeamNotFound = message === "teamNotFound";
    const title = isTeamNotFound ? t('teamNotFound') : t('error');
    const description = isTeamNotFound
        ? t('teamNotFoundDescription', "Cette équipe n'existe plus ou a été supprimée.")
        : t('errorOups');

    return (
        <div className="relative no-scroll min-h-screen bg-modern text-black flex flex-col justify-between overflow-hidden">
            <div className="flex-1 flex flex-col items-center justify-center px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="w-full max-w-sm text-center"
                >
                    {/* Icone */}
                    <div className="w-20 h-20 mx-auto mb-6 bg-red-50 rounded-full flex items-center justify-center">
                        <svg className="w-10 h-10 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                            {isTeamNotFound ? (
                                <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                            )}
                        </svg>
                    </div>

                    {/* Titre */}
                    <h1 className="text-2xl font-bold text-black mb-3">
                        {title}
                    </h1>

                    {/* Description */}
                    <p className="text-gray-500 text-base mb-8 leading-relaxed">
                        {description}
                    </p>

                    {/* Bouton retour */}
                    <a
                        href="https://thetipsyou.fr"
                        className="inline-block w-full px-6 py-4 bg-black text-white font-bold rounded-2xl shadow-lg text-lg hover:bg-gray-900 transition hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
                    >
                        TipsYou
                    </a>
                </motion.div>
            </div>

            <Footer />
        </div>
    );
};

export default ErrorPage;
